import type { FaireProductEntity } from "../../entity_types/product";

export const p_bx9yktx6gt: FaireProductEntity = {
  token: "p_bx9yktx6gt",
  type: "product",
  name: "7 Colors Sibling Baby Kids Long Sleeves Team Sprinkles Drips Hoodies Tops",
  brandToken: "b_tbys5jk9cz",
  brandName: "Aier Wholesale",
  imageUrl:
    "https://cdn.faire.com/fastly/b0947a1f9ad672e126dadf3c089becd3a3b4c7de352cd400986c1071ddc5424a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5b2939b41ba49a39ad372de3c8982894693c55c6d01518fca29388020ebd7162.jpeg",
    "https://cdn.faire.com/fastly/b99adf7e91fde948bdcc70e8f9284f12fce5da2c0436064cd4fd33f7ef8c7153.jpeg",
    "https://cdn.faire.com/fastly/4a804a5a4052bfbd1e80943848a1d48f9b9b014a3ba26035681300cce18ab9c7.jpeg",
    "https://cdn.faire.com/fastly/114da7f51ed76e06c7ed23231caa9dcb1ecc71f6647725ac97cc476a57145f91.jpeg",
    "https://cdn.faire.com/fastly/93a08aae2c0a3cb28ff1835a1b2166c2bad553558f48867304e2baef55e7a7f9.jpeg",
    "https://cdn.faire.com/fastly/c919ea06229b9a1fbf159269ae2d17186b201e79b674f585b8f6b2654282a21c.jpeg",
    "https://cdn.faire.com/fastly/6dd7660aa3d813d6bbfd8db7c9a0fc96869ffb890888f633a8d195db83d7923f.jpeg",
  ],
  priceDollars: 10,
  description:
    "Material:milk silk,soft and stretchy\n\nReady to ship\n\nMade in China\n\nShip from China\n\nThe item is ready to ship now,our sizes are true to size.We have been making kids boutique clothing for 12years .\nShipping time:2-4days after order and about 8-12days delivery time.\n\nIf you have any problem with order,please contact me directly,we will do best to help solve~\n",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:21.581Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
